import React, { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Main } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import Spinner from '../../common/Spinner.js';
import { ScrollingCarousel } from '@trendyol-js/react-carousel';
import RightArrow from '../../../static/img/right-arrow.svg';

// Import tab components
import Profile from './Profile.js';
import TemplateDetail from './TemplateDetail.js';
import ConfigAddEdit from '../manageListingConfigurration/ConfigAddEdit.js';
import TemplateConfig from './TemplateConfig.js';

import ExportSettings from '../../profile/exportSettings/ExportSettings';
import ManagePayment from '../../profile/managePayment/ManagePayment.js';
import ManagePMS from '../managePms/ManagePMS';
import UserForms from '../userForms/UserForms.js';
import Configurations from '../configuration/configurations.js';
import HostConfiguration from '../hostConfiguration/index.js';
import Tasks from './Tasks';

function ManageSetting() {
  const { adminLoginRoleID} = global;
  const getUser = JSON.parse(localStorage.getItem('user'));      

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { hostSlug: slugFromParams = '' } = useParams();
  const hostSlug = slugFromParams || getUser?.slug || '';
  const exportSettingsRef = useRef();
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [activeTab, setActiveTab] = useState(adminLoginRoleID === getUser?.role_id ? 9 : 1);
  const [btnText, setBtnText] = useState('Edit');
  const [isHostConfigDetail, setIsHostConfigDetail] = useState(location?.state?.isdetail ?? true);
  const paymentMethodsShow = global.checkPermission('payment-method-index') && global.isShowCardsOnFile;
  const shouldAddClass = [9].includes(activeTab) || (activeTab === 1 && getUser?.role_id != adminLoginRoleID);
  const handletab = (tabIds) => {
    if (tabIds === 9) setIsHostConfigDetail(true);
    setActiveTab(tabIds);
  };

  const handleParentSave = () => {
    if (exportSettingsRef.current) {
      exportSettingsRef.current.submitForm(); // triggers child form submit
    }
  };


  return (
    <>
      <Main className={`mainBlock setting-mainBlock ${activeTab === 9 && isHostConfigDetail ? 'host-config-tabs-active' : ''}`}>
        <Row gutter={15} className="mb-0">
          <Col xs={24}>
            <div className="d-flex pageheader justify-content-between waiver-report-pageheader">
              <div className="custom-carousel-tabs-menu">
                <ScrollingCarousel
                  rightIcon={
                    <span className="arrow-btn">
                      <img src={RightArrow} alt="Right" />
                    </span>
                  }
                  leftIcon={
                    <span className="arrow-btn">
                      <img src={RightArrow} alt="Left" style={{ transform: 'rotate(180deg)' }} />
                    </span>
                  }
                  className="swipesection scroll_nav_mob"
                >
                  {global.checkPermission('settings-host-configuration') && (
                    <div
                      className={`ant-menu-item ${activeTab === 9 ? 'ant-menu-item-selected-tab' : 'deactive'}`}
                      onClick={() => handletab(9)}
                    >
                    Admin
                    </div>
                   )}
                  <div
                    className={`ant-menu-item h-68 ${activeTab === 1 ? 'ant-menu-item-selected-tab' : 'deactive'}`}
                    onClick={() => handletab(1)}
                  >
                    Profile
                  </div>
                  {
                    global.checkPermission("user-listing-defaults-show")
                      ?
                      <div
                        className={`ant-menu-item h-68 ${activeTab === 8 ? 'ant-menu-item-selected-tab' : 'deactive'}`}
                        onClick={() => handletab(8)}
                      >
                        Defaults
                      </div>
                      : <></>
                  }

                  {global.checkPermission('settings-feature-configuration') && (
                    <div
                      className={`ant-menu-item ${activeTab === 7 ? 'ant-menu-item-selected-tab' : 'deactive'}`}
                      onClick={() => handletab(7)}
                    >
                      Configurations
                    </div>
                   )}

                  {global.checkPermission('pms-integration-index') && (
                    <div
                      className={`ant-menu-item ${activeTab === 2 ? 'ant-menu-item-selected-tab' : 'deactive'}`}
                      onClick={() => handletab(2)}
                    >
                      Integrations
                    </div>
                  )}
                  {paymentMethodsShow && (
                    <div
                      className={`ant-menu-item ${activeTab === 3 ? 'ant-menu-item-selected-tab' : 'deactive'}`}
                      onClick={() => handletab(3)}
                    >
                      Cards On File
                    </div>
                  )}
                  {/* {global.isSchedularEnableHost && ( */}
                  <div
                    className={`ant-menu-item ${activeTab === 4 ? 'ant-menu-item-selected-tab' : 'deactive'}`}
                    onClick={() => handletab(4)}
                  >
                    Messages
                  </div>

                  {global.checkPermission('form-index') && (
                    <div
                      className={`ant-menu-item ${activeTab === 6 ? 'ant-menu-item-selected-tab' : 'deactive'}`}
                      onClick={() => handletab(6)}
                    >
                      Forms
                    </div>
                  )}
                  {global.checkPermission('settings-index') && (
                    <div
                      className={`ant-menu-item ${activeTab === 5 ? 'ant-menu-item-selected-tab' : 'deactive'}`}
                      onClick={() => handletab(5)}
                    >
                      CRM
                    </div>
                  )}
                  {(global.checkPermission('host-setting-task-index')) && (
                    <div
                      className={`ant-menu-item ${activeTab === 10 ? 'ant-menu-item-selected-tab' : 'deactive'}`}
                      onClick={() => handletab(10)}
                    >
                      Tasks
                    </div>
                  )}
                </ScrollingCarousel>
              </div>

              {/* <PageHeader
                className="pageheaderButton mobile_view_hide"
                ghost
                buttons={[
                  <Button
                    className="mobile_view_hide_btn"
                    size="default"
                    shape="circle"
                    type="primary"
                    key="1"
                    onClick={handleParentSave}
                  >
                    {btnText}
                  </Button>,
                ]}
              /> */}
            </div>
            <div className={`global_search_filter ${shouldAddClass ? "upcoming_filter_tab_btn" : ""}`}></div>
          </Col>
        </Row>

        <Row gutter={15}>
          <Col xs={24}>
            <Spinner loader={spinnerLoader} />
            {activeTab === 1 && <Profile key={hostSlug} />}
            {activeTab === 2 && (
              <div className="manage-pms-content">
                {' '}
                <ManagePMS key={hostSlug} />{' '}
              </div>
            )}
            {activeTab === 3 && <ManagePayment key={hostSlug} />}
            {activeTab === 4 && <TemplateDetail key={hostSlug} />}
            {activeTab === 5 && (
              <div className="crm-setting">
                {' '}
                <ExportSettings key={hostSlug} />{' '}
              </div>
            )}
            {activeTab === 6 && 
            <div className="crm-setting">
            <UserForms key={hostSlug} />
            </div>
            }
            {activeTab === 7 && <div className="crm-setting"><Configurations key={hostSlug} /></div>}
            {activeTab === 8 && <ConfigAddEdit key={hostSlug} />}
            {activeTab === 9 && <div className="crm-setting"><HostConfiguration key={hostSlug} onIsDetailsChange={setIsHostConfigDetail} /></div>}
            {activeTab === 10 && <Tasks key={hostSlug} hostSlug={hostSlug} />}
          </Col>
        </Row>
      </Main>
    </>
  );
}

export default ManageSetting;
